(function () {
  'use strict';

  angular
    .module('complaints')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('complaints', {
        url: '/complaints',
        params: {
          type: 'complaint'
        },
        templateUrl: 'messages/messages.tpl.html',
        controller: 'MessagesCtrl',
        controllerAs: 'messages'
      })
      .state('complaint-reply', {
        url: '/complaints-new/:messageId',
        templateUrl: 'messages/new-message.tpl.html',
        controller: 'NewMessageCtrl',
        controllerAs: 'newMessage',
        params: {
          type: 'complaint'
        }
        
      })
      .state('complaint-new', {
        url: '/complaints-new',
        params: {
          type: 'complaint'
        },
        templateUrl: 'messages/new-message.tpl.html',
        controller: 'NewMessageCtrl',
        controllerAs: 'newMessage'
      })
      .state('complaints.overview', {
        url: '/complaints/overview',
        templateUrl: 'complaints/complaints.tpl.html',
        controller: 'ComplaintsCtrl',
        controllerAs: 'complaints'
      })
      .state('complaints-new', {
        url: '/complaint',
        params: {
          transactionId: null,
          accountId: null
        },
        templateUrl: 'complaints/new-complaint/new-complaint.tpl.html',
        controller: 'ComplaintCtrl',
        controllerAs: 'complaint'
      });
  }
}());
